import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const TemplateWidgetAsyncComponent = AsyncComponent(async () => import('./correct-score-widget' /* webpackChunkName: "correct-score-widget" */ ));

export const CorrectScoreWidgetAsync = (props) => {
  return <TemplateWidgetAsyncComponent {...props}/>

  //Add Suspense only if needed
  // <React.Suspense fallback={<div/>}>
  //   <TemplateWidgetAsyncComponent {...props}/>
  // </React.Suspense>
};
